import React, { useEffect, useState, useCallback } from 'react';
import { InputText } from 'primereact/inputtext';
import { Dropdown } from 'primereact/dropdown';
import { Button } from 'primereact/button';
import { Divider } from 'primereact/divider';
import { useLanguage } from '../../../../contexts/LanguageContext';
import { REQUEST_STATUS } from '../utils/statusBadges';

const initialFilters = {
    chassisNo: '',
    status: null
};

const MyPurchaseRequestsFilter = ({ filters, onApplyFilters, onReset }) => {
    const { th } = useLanguage();
    const [filterOpen, setFilterOpen] = useState(false);
    const [localFilters, setLocalFilters] = useState({ ...initialFilters, ...filters });

    useEffect(() => {
        setLocalFilters({ ...initialFilters, ...filters });
    }, [filters]);

    const toggleOpen = useCallback(() => setFilterOpen((prev) => !prev), []);

    const handleChange = (field, value) => {
        setLocalFilters((prev) => ({ ...prev, [field]: value }));
    };

    const handleApply = () => {
        onApplyFilters(localFilters);
    };

    const handleReset = () => {
        onReset();
    };

    const handleKeyDown = (e) => {
        if (e.key === 'Enter') handleApply();
    };

    const statusOptions = [
        { label: th('vehiclesForSale.requestStatus.pending'), value: REQUEST_STATUS.PENDING },
        { label: th('vehiclesForSale.requestStatus.approved'), value: REQUEST_STATUS.APPROVED },
        { label: th('vehiclesForSale.requestStatus.rejected'), value: REQUEST_STATUS.REJECTED },
        { label: th('vehiclesForSale.requestStatus.cancelled'), value: REQUEST_STATUS.CANCELLED }
    ];

    return (
        <div className="generic-table-filter">
            <div className="grid">
                <div className="col-12 md:col-6 flex justify-content-start">
                    <Button
                        icon="pi pi-filter"
                        label={th('filter.advancedFilter')}
                        onClick={toggleOpen}
                        outlined={!filterOpen}
                    />
                </div>
            </div>

            {filterOpen && (
                <div className="mt-3">
                    <Divider />
                    <div className="text-xl font-medium mb-3">
                        {th('filter.advancedFilters')}
                    </div>

                    <div className="grid">
                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field">
                                <label className="block mb-2 text-sm">
                                    {th('vehiclesForSale.labels.chassisFilter')}
                                </label>
                                <InputText
                                    value={localFilters.chassisNo}
                                    onChange={(e) => handleChange('chassisNo', e.target.value)}
                                    onKeyDown={handleKeyDown}
                                    className="w-full"
                                    placeholder={th('vehiclesForSale.placeholders.chassisNo')}
                                />
                            </div>
                        </div>

                        <div className="col-12 md:col-6 lg:col-3">
                            <div className="field">
                                <label className="block mb-2 text-sm">
                                    {th('vehiclesForSale.labels.requestStatus')}
                                </label>
                                <Dropdown
                                    value={localFilters.status}
                                    options={statusOptions}
                                    onChange={(e) => handleChange('status', e.value)}
                                    className="w-full"
                                    placeholder={th('vehiclesForSale.placeholders.status')}
                                    showClear
                                />
                            </div>
                        </div>
                    </div>

                    <div className="flex justify-content-start mt-3 mb-3 gap-2">
                        <Button
                            label={th('filter.reset')}
                            icon="pi pi-refresh"
                            className="p-button-outlined"
                            onClick={handleReset}
                        />
                        <Button
                            label={th('filter.apply')}
                            icon="pi pi-search"
                            onClick={handleApply}
                        />
                    </div>
                </div>
            )}
        </div>
    );
};

export default MyPurchaseRequestsFilter;
